import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { useStyles } from '../../hooks/useStyles';
import { Stack } from '../Stack';
import { cardTitleStyles } from './CardTitle.styles';
import { cardTitleTheme } from './CardTitle.stylex';
export const CardTitle = createPolymorphicComponent(forwardRef(function CardTitle(props, forwardedRef) {
    const { styles, sx, headline, subhead, supportingText, ...other } = props;
    const { getStyles, globalStyles } = useStyles({
        name: 'CardTitle',
        styles: [cardTitleStyles, styles],
    });
    return (_jsxs(Stack, { gap: 2, ...other, sx: [cardTitleTheme, globalStyles, sx], ref: forwardedRef, children: [_jsxs("div", { ...getStyles('header'), children: [headline ? _jsx("div", { ...getStyles('headline'), children: headline }) : null, subhead ? _jsx("div", { ...getStyles('subhead'), children: subhead }) : null] }), supportingText ? (_jsx("div", { ...getStyles('supportingText'), children: supportingText })) : null] }));
}));
